import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./AboutUs.css";
import car from "../../Assets/pngegg.png";
import { ContentPageSkeleton } from "../Components/Skeleton/Skeleton";
import PageLoadGate from "../Components/Skeleton/PageLoadGate";
import { MyContext } from "../Context/MyContext";

export default function AboutUs() {
  const navigate = useNavigate();
  const { aboutUs, dataLoading } = useContext(MyContext);

  if (dataLoading || !aboutUs?.hero?.title) {
    return <PageLoadGate skeleton={<ContentPageSkeleton />} delay={380} />;
  }

  return (
    <PageLoadGate skeleton={<ContentPageSkeleton />} delay={380}>
    <div className="about-page">

<section className="about-hero">
<div className="hero-content">
<h1>{aboutUs.hero.title}</h1>
<p>{aboutUs.hero.subtitle}</p>
<button className="hero-btn" onClick={() => navigate("/cars")}>
Browse Cars
</button>
</div>
<div className="hero-car">
 <img src={car} alt="car" className="car-img" />
</div>
</section>

<section className="about-company">
<div className="about-container">
<div className="about-image">
<img
src="https://images.unsplash.com/photo-1502877338535-766e1452684a"
alt="car showroom"
/>
</div>
<div className="about-text">
<h5>{aboutUs.company?.heading}</h5>
<h2>{aboutUs.company?.title}</h2>
<p>{aboutUs.company?.description}</p>
<ul>
{(aboutUs.company?.features || []).map((feature, index) => (
<li key={index}>✔ {feature}</li>
))}
</ul>
</div>
</div>
</section>

<section className="features-new">
<div className="features-left">
<h2>{aboutUs.features?.title}</h2>
<p>{aboutUs.features?.description}</p>
<button className="about-btn" onClick={() => navigate("/cars")}>
Explore Cars
</button>
</div>
<div className="features-right">
{(aboutUs.features?.list || []).map((item) => (
<div className="feature-item" key={item.id}>
<span className="feature-icon">{item.icon}</span>
<div>
<h3>{item.title}</h3>
<p>{item.desc}</p>
</div>
</div>
))}
</div>
</section>

<section className="about-stats">
<div className="stats-container">
{(aboutUs.stats || []).map((stat) => (
<div className="stat-box" key={stat.id}>
<h2>{stat.value}</h2>
<p>{stat.label}</p>
</div>
))}
</div>
</section>

<section className="about-cta">
<div className="cta-container">
<div className="cta-left">
<h2>{aboutUs.cta?.title}</h2>
<p>{aboutUs.cta?.description}</p>
<button className="cta-btn" onClick={() => navigate("/cars")}>
{aboutUs.cta?.button}
</button>
</div>
<div className="cta-right">
<img src={car} alt="car" className="cta-car"/>
</div>
</div>
</section>

</div>
    </PageLoadGate>
  );
}
